import React from 'react';
import styled from 'styled-components';

import MetaTags from 'components/meta-tags';
import { GoogleLogin } from 'components/social-login/google-login';
import { AppleLogin } from 'components/social-login/apple-login';
import type { IrlEvent } from 'src/gql/graphql';
import { Card } from './card';
import { IrlEventLogo } from './irl-event-logo';
import { ContentHeader, Heading, Description, FooterLink, Content } from './styles';
import { useIrlEventParams } from '../hooks/use-irl-event-params';

type IrlEventSignupStartProps = {
  irlEvent: IrlEvent;
  onContinueWithEmail: () => void;
};

export function IrlEventSignupStart({ irlEvent, onContinueWithEmail }: IrlEventSignupStartProps): JSX.Element {
  const { publicContextSessionId } = useIrlEventParams();

  // Build redirect URL with authSource param for tracking social login success
  const redirectUrl = (() => {
    if (typeof window === 'undefined') {
      return '';
    }
    const url = new URL(window.location.href);
    url.searchParams.set('authSource', 'social');
    return url.toString();
  })();

  const { title, description, headerImageUrl } = irlEvent;

  return (
    <>
      <MetaTags title={title} description={description} />

      <Card data-testid='irl-event-signup-start'>
        <IrlEventLogo headerImageUrl={headerImageUrl ?? null} />

        <ContentHeader>
          <Heading data-testid='irl-event-signup-start-title'>{title}</Heading>
          <Description data-testid='irl-event-signup-start-description'>{description}</Description>
        </ContentHeader>

        <Content>
          <SocialLogins>
            <GoogleLogin redirectUrl={redirectUrl} publicContextSessionId={publicContextSessionId} />
            <AppleLogin redirectUrl={redirectUrl} publicContextSessionId={publicContextSessionId} />
          </SocialLogins>

          <FooterLink onClick={onContinueWithEmail} data-testid='irl-event-continue-with-email'>
            Continue with email
          </FooterLink>
        </Content>
      </Card>
    </>
  );
}

const SocialLogins = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin: 0 auto 25px;
`;
